export const SETUP_DRAWER_OPENED_KEY = 'bottleSetupDrawerOpened'

// Unreadable storage reads as never opened: showing the review again costs a
// click, skipping it costs the merchant the one look at their details the drawer
// exists to give them.
export function hasOpenedSetupDrawer() {
  try {
    return localStorage.getItem(SETUP_DRAWER_OPENED_KEY) === 'true'
  } catch {
    return false
  }
}

export function markSetupDrawerOpened() {
  try {
    localStorage.setItem(SETUP_DRAWER_OPENED_KEY, 'true')
  } catch {
    // storage unavailable; best-effort
  }
}

// A merchant who has never opened the drawer was brought here to look over what
// the journey filled in for them, so the first open starts at the top however
// much of it already reads as done. Opening on the first outstanding step would
// scroll them straight past the details they came to check.
export function initialOpenStepKey(steps, alreadyOpened) {
  if (!steps.length) return null
  if (!alreadyOpened) return steps[0].key

  const outstanding = steps.find(step => !step.complete)
  return outstanding ? outstanding.key : null
}
